<template>
  <div
    style="text-align: right;"
    class="proform-customer-order-actions"
  >
    <el-dropdown
      ref="dropDown"
      size="small"
      @command="handleAction"
    >
      <el-button
        size="mini"
        class="el-dropdown-link"
        @click.stop="toggleDropDown"
      >
        <i :class="!buttonLoader ? 'el-icon-more' : 'el-icon-loading'"/>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-can="'customerorder.update'"
          :command="copyProformCustomerOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-document-copy"/> Másolás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="proformCustomerOrder.status === 'waiting-for-payee'"
          v-can="'customerorder.create'"
          :command="createCustomerOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-goods"/> Megrendelés létrehozása
        </el-dropdown-item>
        <el-dropdown-item
          v-if="proformCustomerOrder.status !== 'recorded' && proformCustomerOrder.status !== 'cancelled' && proformCustomerOrder.invoices.length === 0"
          v-can="['invoice.create']"
          :command="openInvoiceDialog"
          :disabled="buttonLoader"
        >
          <i class="el-icon-document"/> Előlegszámla létrehozása
        </el-dropdown-item>
        <el-dropdown-item
          v-if="proformCustomerOrder.status === 'waiting-for-payee' && proformCustomerOrder.invoices.length === 0"
          v-can="['customerorder.create', 'invoice.create']"
          :command="createCustomerOrderAndOpenInvoiceDialog"
          :disabled="buttonLoader"
        >
          <i class="el-icon-document-add"/> Megrendelés és előlegszámla létrehozása
        </el-dropdown-item>
        <el-dropdown-item
          v-if="proformCustomerOrder.status === 'waiting-for-payee'"
          v-can="'proformcustomerorder.update'"
          :command="cancelProformCustomerOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-close"/> Érvénytelenítés
        </el-dropdown-item>
        <!--<el-dropdown-item-->
          <!--v-if="proformCustomerOrder.status !== 'recorded' && proformCustomerOrder.status !== 'cancelled' && proformCustomerOrder.receipt_file"-->
          <!--v-can="'proformcustomerorder.view'"-->
          <!--:command="openReceipt"-->
          <!--:disabled="buttonLoader"-->
        <!--&gt;-->
          <!--<i class="el-icon-printer"/> Bizonylat nyomtatása-->
        <!--</el-dropdown-item>-->
        <el-dropdown-item
          v-if="proformCustomerOrder.status === 'recorded'"
          v-can="'proformcustomerorder.update'"
          :command="sendOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-check"/> Véglegesítés
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'proformcustomerorder.update'"
          v-if="proformCustomerOrder.status === 'recorded'"
          :command="updateRproformCustomerOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-edit"/> Módosítás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="proformCustomerOrder.status === 'recorded'"
          v-can="'proformcustomerorder.delete'"
          :command="openDeleteConfirmation"
          :disabled="buttonLoader"
        >
          <i class="el-icon-delete"/> Törlés
        </el-dropdown-item>
        <el-dropdown-item
          :command="exportExcel"
          :disabled="buttonLoader"
        >
          <i class="el-icon-download"/> Excel exportálás
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog
      title="Előlegszámla számlatömbje"
      :visible.sync="dialogVisible"
      append-to-body
      width="520px"
    >
      <p>Számlatömb</p>
      <el-select
        v-model="invoiceBookId"
        style="width: 100%;"
        filterable
        v-loading="invoiceBookLoading"
      >
        <el-option
          v-for="invoiceBook in invoiceBooks"
          :key="invoiceBook.id"
          :value="invoiceBook.id"
          :label="invoiceBook.name"
        />
      </el-select>
      <div slot="footer">
        <el-button @click="dialogVisible = false">Mégsem</el-button>
        <el-button
          :disabled="!invoiceBookId"
          :loading="invoiceLoader"
          type="primary"
          @click="createInvoice"
        >
          Előlegszámla létrehozása
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['proformCustomerOrder'],
  data() {
    return {
      dialogVisible: false,
      buttonLoader: false,
      invoiceBookLoading: false,
      invoiceLoader: false,
      invoiceBookId: null,
      deleteConfirmVisible: false,
    };
  },
  computed: {
    invoiceBooks() {
      return this.$store.getters['invoiceBook/invoiceBooks'];
    },
  },
  methods: {
    async deleteProformCustomerOrder() {
      this.buttonLoader = true;
      this.deleteConfirmVisible = false;
      try {
        await this.$store.dispatch('proformCustomerOrder/delete', this.proformCustomerOrder.id);
        this.$store.dispatch('proformCustomerOrder/fetchAll');
      } catch (e) {
      }
      this.buttonLoader = false;
    },
    async updateRproformCustomerOrder() {
      this.$router.push('/sales/proform-customer-orders/update/' + this.proformCustomerOrder.id);
    },
    copyProformCustomerOrder() {
      this.$router.push('/sales/proform-customer-orders/add/' + this.proformCustomerOrder.id);
    },
    async sendOrder() {
      this.buttonLoader = true;
      try {
        await this.$store.dispatch('proformCustomerOrder/send', this.proformCustomerOrder.id);
        this.$store.dispatch('proformCustomerOrder/fetchAll');
      } catch (e) {
      }
      this.buttonLoader = false;
    },
    async createCustomerOrder() {
      this.buttonLoader = true;
      try {
        await this.$store.dispatch('proformCustomerOrder/createCustomerOrder', this.proformCustomerOrder.id);
        this.$store.dispatch('proformCustomerOrder/fetchAll');
      } catch (e) {
      }
      this.buttonLoader = false;
    },
    async createInvoice() {
      this.invoiceLoader = true;
      try {
        await this.$store.dispatch('proformCustomerOrder/createInvoice', {
          id: this.proformCustomerOrder.id,
          invoiceBookId: this.invoiceBookId,
        });
        this.$store.dispatch('proformCustomerOrder/fetchAll');
        this.dialogVisible = false;
      } catch (e) {
      }
      this.invoiceLoader = false;
    },
    async createCustomerOrderAndOpenInvoiceDialog() {
      this.invoiceBookId = null;
      this.createCustomerOrder();
      if (!this.invoiceBooks || this.invoiceBooks.length === 0) {
        this.invoiceBookLoading = true;
        try {
          await this.$store.dispatch('invoiceBook/fetchAll', '');
        } catch (e) {
        }
        this.invoiceBookLoading = false;
      }
      this.dialogVisible = true;
    },
    async openInvoiceDialog() {
      this.invoiceBookId = null;
      if (!this.invoiceBooks || this.invoiceBooks.length === 0) {
        this.invoiceBookLoading = true;
        try {
          await this.$store.dispatch('invoiceBook/fetchAll', '');
        } catch (e) {
        }
        this.invoiceBookLoading = false;
      }
      this.dialogVisible = true;
    },
    async cancelProformCustomerOrder() {
      this.buttonLoader = true;
      try {
        await this.$store.dispatch('proformCustomerOrder/cancel', this.proformCustomerOrder.id);
        this.$store.dispatch('proformCustomerOrder/fetchAll');
      } catch (e) {
      }
      this.buttonLoader = false;
    },
    openReceipt() {
      if (this.proformCustomerOrder.receipt_file && this.proformCustomerOrder.receipt_file.path) {
        window.open(this.proformCustomerOrder.receipt_file.path);
      }
    },
    openDeleteConfirmation() {
      this.$confirm('Ez a folyamat nem visszafordítható és a kapcsolódó elemek is törölve lesznek.', 'Biztosan törölni szeretnéd?', {
        confirmButtonText: 'Igen',
        cancelButtonText: 'Mégse',
        type: 'warning',
      })
        .then(() => {
          this.deleteProformCustomerOrder();
        })
        .catch(() => {
          this.$router.replace('/sales/proform-customer-orders');
        });
    },
    handleAction(action) {
      action();
    },
    toggleDropDown() {
      this.$refs['dropDown'].visible = !this.$refs['dropDown'].visible;
    },
    async exportExcel() {
      try {
        this.buttonLoader = true;
        const excel = await axios({
          url: 'api/proform-customer-orders/' + this.proformCustomerOrder.id + '/export',
          method: 'GET',
          responseType: 'blob',
        });
        saveAs(excel, 'proform_customer_order_items.xlsx');
      } catch (e) {
      }
      this.buttonLoader = false;

    },
  }
};
</script>
<style lang="scss">
  .proform-customer-order-actions {
    padding: 0 !important;
    float: right;
    line-height: 1;

    .el-dropdown {
      padding-right: 0;
    }
  }
</style>
